import axios from "axios";
import { interpretApiError } from "../systems/responseInterpreter";

const baseURL =
  process.env.REACT_APP_API_BASE_URL?.trim() || "http://127.0.0.1:8000";

const DEFAULT_TIMEOUT = 30000;
const STUDIO_TIMEOUT = 90000;

const API = axios.create({
  baseURL,
  timeout: DEFAULT_TIMEOUT,
});

const isLongRunningStudioRequest = (config) => {
  const url = (config?.url || "").toLowerCase();

  return (
    url.startsWith("/studio/") ||
    url.startsWith("/hooks/generate") ||
    (url.includes("/hooks/") && url.endsWith("/regenerate"))
  );
};

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.timeout = isLongRunningStudioRequest(config)
    ? STUDIO_TIMEOUT
    : DEFAULT_TIMEOUT;

  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    const interpreted = interpretApiError(error);

    if (interpreted.type === "upgrade") {
      window.dispatchEvent(
        new CustomEvent("hookora:upgrade-required", {
          detail: interpreted,
        })
      );
    }

    if (interpreted.type === "auth") {
      localStorage.removeItem("access_token");

      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default API;
